import { Checkbox } from "react-aria-components";

import { CheckboxControl } from "../../inputs/checkbox/CheckboxControl";

export function TableCheckbox() {
  return (
    <Checkbox slot="selection">
      {({
        isIndeterminate,
        isSelected,
        isDisabled,
        isFocusVisible,
        isHovered,
      }) => (
        <CheckboxControl
          isIndeterminate={isIndeterminate}
          isSelected={isSelected}
          isDisabled={isDisabled}
          isFocusVisible={isFocusVisible}
          isHovered={isHovered}
        />
      )}
    </Checkbox>
  );
}
